module.exports = __webpack_public_path__ + "static/media/zheng10.bee98ee2.png";